import OpportunityDetails from "./components/OpportunityDetails";

export default OpportunityDetails;